export type TableRowRecord = Record<string, unknown>;

export function normalizeProTableDataSource(
  dataSource: unknown,
): TableRowRecord[] {
  return Array.isArray(dataSource)
    ? dataSource.filter(
        (item): item is TableRowRecord =>
          Boolean(item) && typeof item === "object" && !Array.isArray(item),
      )
    : [];
}

export function hasTableRequestBinding(
  eventMap: Record<string, unknown> | undefined,
): boolean {
  const binding = eventMap?.["table.request"];
  if (!binding || typeof binding !== "object" || Array.isArray(binding)) {
    return false;
  }
  const current = binding as {
    enabled?: unknown;
    handlerName?: unknown;
    handlerCode?: unknown;
    actions?: unknown;
  };
  if (current.enabled === false) return false;
  if (typeof current.handlerName === "string" && current.handlerName.trim()) {
    return true;
  }
  if (typeof current.handlerCode === "string" && current.handlerCode.trim()) {
    return true;
  }
  return Array.isArray(current.actions) && current.actions.length > 0;
}
